import React from "react"

// import Swiper core and required modules
import { Navigation, Pagination, A11y, Scrollbar } from "swiper/modules"

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react"

// Import Swiper styles
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "swiper/css/scrollbar"

import { ChevronLeft24, ChevronRight24 } from "@carbon/icons-react"

const SliderWrapper = ({ children, className, _uid, showSlides }) => {
  let showDesktopArrows = false
  if (showSlides < children?.length) {
    showDesktopArrows = true
  }

  return (
    <div className={`relative ${className?.length > 0 ? className : ""}`}>
      <Swiper
        modules={[Navigation, Pagination, A11y, Scrollbar]}
        spaceBetween={32} // 0 vs 32px
        slidesPerView={1} // auto vs {1}
        pagination={{
          clickable: true,
          el: ".swiper-pagination-" + _uid,
          bulletClass:
            "swiper-pagination-bullet inline-block w-4 h-4 mx-2 border md:w-6 md:h-6 border-primary hover:bg-primary",
          bulletActiveClass: "bg-primary",
        }}
        navigation={{
          disabledClass: "!bg-gray-400 pointer-events-none",
          nextEl: ".swiper-button-next-" + _uid,
          prevEl: ".swiper-button-prev-" + _uid,
        }}
        scrollbar={{
          el: `#slider-wrapper-swiper-scrollbar-${_uid}`,
          draggable: true,
          dragSize: "auto",
          dragClass: "h-full relative inset-x-0 bg-primary",
        }}
        breakpoints={{
          640: {
            slidesPerView: 2,
            slidesPerGroup: 2,
          },
          // 768: {
          //   slidesPerView: 2,
          //   slidesPerGroup: 2,
          // },
          1024: {
            slidesPerView: showSlides,
            slidesPerGroup: showSlides,
          },
        }}
      >
        {children?.length > 0 &&
          children.map((child, index) => (
            <SwiperSlide key={index} className="flex !h-auto mb-4">
              {child}
            </SwiperSlide>
          ))}
      </Swiper>
      <div
        id={`slider-wrapper-swiper-scrollbar-${_uid}`}
        className="relative touch-none bg-gray-400 h-1.5 inset-x-0 cursor-pointer mt-8"
      ></div>
      <div className="flex justify-end pt-5">
        <button
          className={`swiper-button-prev-${_uid} flex justify-center items-center w-10 h-10 bg-primary text-white hover:bg-primary-hover`}
        >
          <ChevronLeft24 className="-ml-0.5 w-7 h-7" />
        </button>
        <button
          className={`swiper-button-next-${_uid} flex justify-center items-center w-10 h-10 bg-primary text-white hover:bg-primary-hover ml-2`}
        >
          <ChevronRight24 className="-mr-0.5 w-7 h-7" />
        </button>
      </div>
    </div>
  )
}

export default SliderWrapper
